<template>
<svg viewBox="0 0 24 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Suo`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0658 1.70605C8.80946 1.70605 6.16968 4.34584 6.16968 7.60217V11.1771C6.16968 11.2191 6.17012 11.261 6.17099 11.3027H5.71887C4.06202 11.3027 2.71887 12.6459 2.71887 14.3027V20.3887C2.71887 22.0455 4.06202 23.3887 5.71887 23.3887H18.4128C20.0697 23.3887 21.4128 22.0455 21.4128 20.3887V14.3027C21.4128 12.6459 20.0697 11.3027 18.4128 11.3027H17.9606C17.9615 11.261 17.9619 11.2191 17.9619 11.1771V7.60217C17.9619 4.34584 15.3221 1.70605 12.0658 1.70605ZM15.741 11.3027V7.63401C15.741 5.61125 14.1012 3.97148 12.0784 3.97148C10.0557 3.97148 8.41589 5.61125 8.41589 7.63401V11.3027H15.741ZM11.0659 15.7646C11.0659 15.2124 11.5136 14.7646 12.0659 14.7646C12.6182 14.7646 13.0659 15.2124 13.0659 15.7646V18.9277C13.0659 19.48 12.6182 19.9277 12.0659 19.9277C11.5136 19.9277 11.0659 19.48 11.0659 18.9277V15.7646Z"/></svg>
</template>
<script>

export default {
  name: 'IconSuo',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
